import { WordCategory } from '~/containers/ManageWords/components/ManageWordsList';
import { WordLanguage } from '~/types/manageWords';
import { emperor } from '~/services';

export const getForbiddenAndModeratedWords = async (
  building?: string | null
) => {
  return await emperor.get('managewords', {
    params: { building: building === null ? 'null' : building }
  });
};

export const createModeratedWord = async (
  term: string,
  type: WordCategory,
  building?: string | null,
  language: WordLanguage = 'en'
) => {
  return await emperor.post('managewords', { term, type, building: building ?? null, language });
};

export const editModeratedWord = async (
  term: string,
  type: WordCategory,
  uuid: string,
  building?: string | null,
  language?: WordLanguage
) => {
  return await emperor.put(`managewords/${uuid}`, { term, type, building: building ?? null, language });
};

export const deleteModeratedWord = async (
  uuid: string,
  type: WordCategory,
  building?: string | null
) => {
  return await emperor.delete(`managewords/${uuid}`, { params: { type, building: building ?? null } });
};

export const createBlockedWord = async (
  term: string,
  building?: string | null,
  language: WordLanguage = 'en'
) => {
  return await emperor.post('managewords', { term, type: 'blocked', building: building ?? null, language });
};

export const editBlockedWord = async (
  term: string,
  uuid: string,
  building?: string | null,
  language?: WordLanguage
) => {
  return await emperor.put(`managewords/${uuid}`, { id: uuid, term, type: 'blocked', building: building ?? null, language });
};

export const deleteBlockedWord = async (uuid: string) => {
  return await emperor.delete(`managewords/${uuid}`, { params: { type: 'blocked' } });
};
